module.exports = __webpack_public_path__ + "img/medal-disabled.bac25930.svg";